/** @file Degrees to radians (documents hold degrees, math works in radians). */

/** `deg * pi / 180`. */
export function degToRad(deg: number): number {
  return (deg * Math.PI) / 180;
}
